<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">             
            <div class="brand">
              <h1 style="color:black">Produtos Geossintéticos</h1>
              <h3 style="color:black">Atendemos em todo território nacional.</h3>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <index></index>    
      </div>
      <div class="section" style="background: black; padding-bottom: 0; padding-top: 0;">
        <information-footer></information-footer>
      </div>
    </div>    
  </div>
</template>

<script>
import Parallax from "../components/Parallax";
import InformationFooter from "../components/InformationFooter";
import Index from "./Index";

export default {
  name: "layout",
  bodyClass: "layout-page",
  components: { Parallax, InformationFooter, Index },
  props: {
    image: {
      type: String,
      default: require("../assets/home/teste2.jpeg")
    }
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      leafShow: false
    };    
  },
  methods: {
    leafActive() {
      if (window.innerWidth < 768) {
        this.leafShow = false;
      } else {
        this.leafShow = true;
      }
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.image})`
      };
    },
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`
      };
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
  }
};

</script>

<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
